import { Controller } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { isDefined } from 'utils/tsHelpers';
import { useHyperlinkFormContext } from '../../contexts/hyperlinkForm';
import { useTranslation } from '../../../../../../../hooks/useTranslation';

export const DisplayTextInput = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useHyperlinkFormContext();
  return (
    <FormField
      labelText={t('contentPicker.textEditor.displayText')}
      errorText={errors.displayText?.message}
      hasError={isDefined(errors.displayText)}
      isRequired
    >
      <Controller
        name="displayText"
        control={control}
        rules={{ required: t('contentPicker.textEditor.missingLinkDisplayText') }}
        render={({ field }) => (
          <InputText
            {...field}
            data-test="display-text-input"
            placeholder={t('contentPicker.textEditor.placeholderDisplayText')}
          />
        )}
      />
    </FormField>
  );
};
